import {Grid} from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import {digitsEnToFa} from 'persian-tools2';
import {makeStyles} from '@mui/styles';
import styles from 'assets/jss/Card';
import postMeal from 'assets/img/AfterMeal.svg';
import preMeal from 'assets/img/postPurple.svg';
import NoMeal from 'assets/img/undefinedMeal.svg';

const useStyles = makeStyles(styles);

const Card = ({cardData}) => {
    const classes = useStyles();
    const {time, testResult, glucoseStatus, mealStatus, weekday} = cardData || {};
    let labelColor =
        glucoseStatus === 0
            ? 'var(--medium-green)'
            : glucoseStatus === 1
                ? 'var(--light-orange)'
                : glucoseStatus === 2
                    ? 'var(--pink)'
                    : '';
    const mealImages = [NoMeal, postMeal, preMeal]
    const mealText = ['', 'postmeal', 'premeal']
    return (
        <Grid container className={classes.cardContainer} style={{border: `1px solid ${labelColor}`}}>
            {/*---------------------------- first row -----------------------------*/}
            <Grid container alignItems='center'>
                <Grid item xs={5.5} className={classes.date}>
                    {weekday ? digitsEnToFa(weekday) : ''}
                </Grid>
                <Grid item xs={2} className={classes.sugarNumber} style={{color: labelColor}}>
                    {testResult}
                </Grid>
                <Grid item xs={4.5} className={classes.reason}>
                    {mealText[mealStatus]}
                </Grid>
            </Grid>
            {/* ------------------- second row -----------------*/}
            <Grid container className={classes.secondRowContainer}>
                <Grid item xs={5.5} className={classes.clock}>
                    {time}
                </Grid>
                <Grid xs={2} item className={classes.sugarUnit}>
                    <span style={{color: labelColor}}>mg/dl</span>
                    <FiberManualRecordIcon style={{color: labelColor}} className={classes.fiberStyle}/>
                </Grid>
                <Grid item xs={4.5} className={classes.meal}>
                    <img src={mealImages[mealStatus]} alt=''/>
                </Grid>
            </Grid>
        </Grid>

    );
};

export default Card;
